var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"modifiers":['background-grey-pale']}},[_c('header-component',{attrs:{"content-props":{
      hasUserMenu: true,
      hasSearch: true,
      hasDiscoverMenu: true,
      hasLibraryLink: true,
      hasHighlightsLink: true
    }}}),_vm._v(" "),_c('episode-header',{attrs:{"shortcast":_vm.shortcast,"episode":_vm.episode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }